var map = {
	"./0/first.png": 4106,
	"./0/next.png": 8867,
	"./0/preview.jpg": 9876,
	"./0/second.png": 1856,
	"./0/slider/01.png": 9734,
	"./0/slider/02.png": 1301,
	"./0/slider/03.png": 5399,
	"./0/slider/04.png": 2251,
	"./1/first.png": 1299,
	"./1/next.png": 2598,
	"./1/preview.jpg": 3897,
	"./1/second.png": 565,
	"./1/slider/01.png": 638,
	"./1/slider/02.png": 6954,
	"./1/slider/03.png": 2504,
	"./1/slider/04.png": 162,
	"./2/first.png": 1683,
	"./2/next.png": 9822,
	"./2/preview.jpg": 197,
	"./2/second.png": 8125,
	"./2/slider/01.png": 7393,
	"./2/slider/02.png": 8795,
	"./2/slider/03.png": 7513,
	"./2/slider/04.png": 2318
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9773;